import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { SupplierListView } from "./supplier-list.view";
import { SupplierListDataService } from "./supplier-list.data";

export class SupplierListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: SupplierListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = SupplierListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: SupplierSummary | 'General' | 'CarRent') {
        this.props.history.push(`/products/suppliers/${item == 'General' || item == 'CarRent' ? item : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false);
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {

        return  <SupplierListView
            model={ this.dataService }
            setBusy={this.props.setBusy}
            onItemDoubleClicked={this.onItemDoubleClicked} {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/list/supplier-list.controller.tsx